import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { Zap, Calendar } from 'lucide-react';
import { useUIStore } from '@/stores/ui-store';
import type { TriggerNodeData } from '@/types/field-mapping-flow';

function TriggerNodeComponent({ data }: NodeProps) {
  const nodeData = data as unknown as TriggerNodeData;
  const isEvents = nodeData.appType === 'events';
  const Icon = isEvents ? Calendar : Zap;
  const isDark = useUIStore((s) => s.theme) === 'dark';

  return (
    <div
      className="rounded-xl px-5 py-3.5 shadow-md min-w-[240px]"
      style={{
        background: isDark
          ? 'linear-gradient(135deg, #2e1065 0%, #3b0764 100%)'
          : 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
        border: isDark ? '1px solid #6d28d9' : '1px solid #c4b5fd',
      }}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg shadow-sm" style={{ background: isDark ? '#8b5cf6' : '#7c3aed' }}>
          <Icon className="h-4 w-4 text-white" />
        </div>
        <div>
          <p className="text-[10px] font-bold uppercase tracking-wider" style={{ color: isDark ? '#a78bfa' : '#7c3aed' }}>
            Trigger
          </p>
          <p className="text-sm font-semibold text-gray-900 dark:text-foreground">
            {nodeData.label}
          </p>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!h-2.5 !w-2.5 !border-2"
        style={{ borderColor: isDark ? '#8b5cf6' : '#7c3aed', background: isDark ? '#1e1b4b' : 'white' }}
      />
    </div>
  );
}

export const TriggerNode = memo(TriggerNodeComponent);
